export default "__VITE_ASSET__CTTTXnRB__"